/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3ProposalsOverTimeFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3ProposalsOverTimeFormat = ClosedEnum<
  typeof GetApiV3ProposalsOverTimeFormat
>;

export type GetApiV3ProposalsOverTimeRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3ProposalsOverTimeFormat | undefined;
  /**
   * Start Timestamp
   */
  start: number;
  /**
   * Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3ProposalsOverTimeFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3ProposalsOverTimeFormat
> = z.nativeEnum(GetApiV3ProposalsOverTimeFormat);

/** @internal */
export const GetApiV3ProposalsOverTimeFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3ProposalsOverTimeFormat
> = GetApiV3ProposalsOverTimeFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ProposalsOverTimeFormat$ {
  /** @deprecated use `GetApiV3ProposalsOverTimeFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3ProposalsOverTimeFormat$inboundSchema;
  /** @deprecated use `GetApiV3ProposalsOverTimeFormat$outboundSchema` instead. */
  export const outboundSchema = GetApiV3ProposalsOverTimeFormat$outboundSchema;
}

/** @internal */
export const GetApiV3ProposalsOverTimeRequest$inboundSchema: z.ZodType<
  GetApiV3ProposalsOverTimeRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  end: z.nullable(z.number()).default(null),
  format: GetApiV3ProposalsOverTimeFormat$inboundSchema.default("json"),
  start: z.number(),
  step: z.number().default(7200),
});

/** @internal */
export type GetApiV3ProposalsOverTimeRequest$Outbound = {
  end: number | null;
  format: string;
  start: number;
  step: number;
};

/** @internal */
export const GetApiV3ProposalsOverTimeRequest$outboundSchema: z.ZodType<
  GetApiV3ProposalsOverTimeRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3ProposalsOverTimeRequest
> = z.object({
  end: z.nullable(z.number()).default(null),
  format: GetApiV3ProposalsOverTimeFormat$outboundSchema.default("json"),
  start: z.number(),
  step: z.number().default(7200),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ProposalsOverTimeRequest$ {
  /** @deprecated use `GetApiV3ProposalsOverTimeRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3ProposalsOverTimeRequest$inboundSchema;
  /** @deprecated use `GetApiV3ProposalsOverTimeRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3ProposalsOverTimeRequest$outboundSchema;
  /** @deprecated use `GetApiV3ProposalsOverTimeRequest$Outbound` instead. */
  export type Outbound = GetApiV3ProposalsOverTimeRequest$Outbound;
}

export function getApiV3ProposalsOverTimeRequestToJSON(
  getApiV3ProposalsOverTimeRequest: GetApiV3ProposalsOverTimeRequest,
): string {
  return JSON.stringify(
    GetApiV3ProposalsOverTimeRequest$outboundSchema.parse(
      getApiV3ProposalsOverTimeRequest,
    ),
  );
}

export function getApiV3ProposalsOverTimeRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3ProposalsOverTimeRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3ProposalsOverTimeRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3ProposalsOverTimeRequest' from JSON`,
  );
}
